import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconFormHexagon"><Path d="M11.123 1.88863C11.6644 1.57619 12.3317 1.57619 12.873 1.88863L20.3164 6.18648C20.8578 6.49906 21.1913 7.07698 21.1914 7.70211V16.2978C21.1913 16.9229 20.8578 17.5009 20.3164 17.8134L12.873 22.1113C12.3317 22.4237 11.6644 22.4237 11.123 22.1113L3.67969 17.8134C3.13831 17.5009 2.80477 16.9229 2.80469 16.2978V7.70211C2.80476 7.07698 3.1383 6.49906 3.67969 6.18648L11.123 1.88863Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormHexagon;
